<footer id="footer" class="bg-light-gray padding-20px-tb xs-padding-40px-tb">
    <div class="container">
        <div class="row">
            <!-- logo -->
            <div class="col-md-2 col-sm-12 col-12 sm-text-center sm-margin-five-bottom">
                <a href="#home" class="inner-link"><img src="assets/image/Logo-Servios_horizontal_full.png" alt=""></a>
            </div>
            <!-- end logo -->
            <!-- caption -->
            <div class="col-md-8 col-sm-12 col-12 text-center sm-margin-five-bottom text-medium" style="margin: auto;">
                <span class=" alt-font"> Copyright © {{anio}} Servios. Todos los derechos reservados. Desarrollado por
                    <a class="text-blue" href="https://www.linkedin.com/in/jaimeferreira91/">Jaime
                        Ferreira.</a></span>
            </div>
            <!-- end caption -->
            <!-- social elements -->
            <div class="col-md-2 col-sm-12 col-12 text-right sm-text-center social-icon">
                <a href="https://www.facebook.com/s.e.r.v.i.o.s.py/" target="_blank">
                    <i class="fab fa-facebook-square fa-3x" style="color: #1e5663;"></i>
                </a>
                <a href="https://www.instagram.com/s.e.r.v.i.o.s/" target="_blank">
                    <i class="fab fa-instagram-square fa-3x" style="color: #1e5663;"></i>
                </a>

            </div>
        </div>
    </div>
</footer>